function fontStyles(theme) {
    return function() {
        return {
            fontFamily: theme.fontFamily || "sans-serif"
        };
    };
}
export { fontStyles }; //# sourceMappingURL=font-styles.js.map
